module.exports = __webpack_public_path__ + "img/artillery-wagon-base-1.d522426d.png";